



























import Vue from 'vue';
import Component from 'vue-class-component';
import ModelAutocomplete from '@/general/component/form/autocomplete/ModelAutocomplete.vue';
import PageContainer from '@/general/component/PageContainer.vue';
import TextInput from '@/general/component/form/input/TextInput.vue';
import FacilityAutocomplete from '@/general/component/form/autocomplete/FacilityAutocomplete.vue';
import CustomerAutocomplete from '@/general/component/form/autocomplete/CustomerAutocomplete.vue';
import { Api } from '@/common/api/Api';
import ModelRouter from '@/context/model/router/ModelRouter';
import { ModelApi } from '@/context/model/api/ModelApi';
import { ModelFilter } from '@/context/model/model/ModelFilter';

@Component({
  components: {
    CustomerAutocomplete,
    PageContainer,
    FacilityAutocomplete,
    ModelAutocomplete,
    TextInput
  }
})
export default class ModelListContainer extends Vue {
  router: ModelRouter = ModelRouter.instance();
  deleteApi: Api = ModelApi.instance();
  filter: ModelFilter = new ModelFilter();
  entityHeaders: Array<Record<string, unknown>> = [
    {
      text: "Producent",
      value: "manufacturer",
      align: "left"
    },
    {
      text: "Model",
      value: "model",
      align: "left"
    }
  ];
  api: Api = ModelApi.instance();
}
